import React from 'react';
import styled from 'styled-components';
import { BeatLoader } from 'react-spinners';

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: transparent;
`;

const LoadingComponent = () => {
  return (
    <LoadingContainer>
      <BeatLoader size={15} color={'var(--accent)'} loading={true} />
    </LoadingContainer>
  );
};

export default LoadingComponent;
